import store from '@/store';

const axios = require('axios');

const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_API,
    timeout: 5000,
    headers: {
      'Content-Type': 'application/json'
    }
});
axiosInstance.interceptors.request.use(function (config) {
    const token = store.getters['auth/authentication'];
    config.headers.Authorization =  'Bearer '+token;
    return config;
});

export {axiosInstance, axios};
